
<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div
      class="sidebar-menu-con"
      :style="{
        width: shrink ? '60px' : '240px',
        overflow: shrink ? 'visible' : 'auto',
      }"
    >
      <scroll-bar ref="scrollBar">
        <shrinkable-menu
          :shrink="shrink"
          @on-change="handleSubmenuChange"
          @changeShow="changeShow"
          @changeDpwm="changeDpwm"
          @on-open-change="handleResize"
          :theme="menuTheme"
          :open-names="openedSubmenuArr"
          :menu-list="menuList"
          :menuShow="menuShow"
          :isDown="isDown"
        >
          <div slot="top" class="logo-con">
            <div class="logo-name" v-show="!shrink">
              <span>
                <img src="@/assets/img/logo.svg" alt="" style="width: 130px;" />
              </span>
            </div>
            <div class="logo-name-shrink" v-show="shrink">
              <img src="@/assets/img/logo-s.svg" alt="" style="width: 20px;" />
            </div>
          </div>
        </shrinkable-menu>
      </scroll-bar>

      <!--SidebarFooter-->
      <div v-show="!shrink" class="sidebar-menu-footer">
        <div
          v-if="hasMetadata"
          :class="
            matedateclack ? 'sidebar-footer-item' : 'sidebar-footer-item-clack'
          "
          @click="goMetaPage"
          style="border-right: 1px solid #1d2129"
        >
          <Icon custom="i-custom icon-metadata" />
          元数据
        </div>
        <div
          v-if="hasBookMark"
          :class="
            bookclack ? 'sidebar-footer-item' : 'sidebar-footer-item-clack'
          "
          @click="getBookmark"
        >
          <Icon custom="i-custom icon-book-mark" />
          书签
        </div>
      </div>
      <Dropdown
        class="sidebar-menu-footer-shrink"
        v-show="shrink"
        transfer
        placement="right-end"
        @on-click="turnToPage"
      >
        <img src="@/assets/img/setting.svg" alt="" style="width: 20px;" />

        <DropdownMenu style="width: 200px" slot="list">
          <DropdownItem name="metadata">
            <Icon custom="i-custom icon-metadata" />
            <span style="padding-left: 10px">元数据</span>
          </DropdownItem>
          <DropdownItem name="bookmark">
            <Icon custom="i-custom icon-book-mark" />
            <span style="padding-left: 10px">书签</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div
      class="main-header-con"
      :style="{ paddingLeft: shrink ? '60px' : '240px' }"
    >
      <div class="main-header">
        <!--收起图标-->
        <div class="navicon-con">
          <Button
            :style="{
              transform: 'rotateZ(' + (this.shrink ? '180' : '0') + 'deg)',
            }"
            type="text"
            @click="toggleClick"
          >
            <Icon type="md-menu" size="32"></Icon>
          </Button>
        </div>
        <!--当前路径-->
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
          </div>
        </div>
        <!--项目切换-->
        <div class="header-project-con">
          <div>当前项目：</div>
          <div class="current-project" v-show="currentPro">
            <span
              class="current-project-name"
              @click="projectTitle !== '无' ? (currentPro = false) : ''"
              >{{ projectTitle }}</span
            >
          </div>
          <div v-show="!currentPro">
            <Select @on-change="chgProject">
              <Option
                v-for="project in projectList"
                :value="project.id + '_' + project.cname"
                :key="project._uid"
              >
                {{ project.cname }}
              </Option>
            </Select>
          </div>
        </div>
        <!--右侧工具-->
        <div class="header-avator-con">
          <!--全屏按钮-->
          <full-screen
            v-model="isFullScreen"
            @on-change="fullscreenChange"
          ></full-screen>

          <div class="user-dropdown-menu-con">
            <Row
              type="flex"
              justify="end"
              align="middle"
              class="user-dropdown-innercon"
            >
              <Icon type="md-person" size="20" color="#0084FF"></Icon>
              <Dropdown trigger="click" @on-click="handleClickUserDropdown">
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="md-arrow-dropdown"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem
                    v-for="dropItem in dropDownList"
                    :name="dropItem.name"
                    :key="dropItem._uid"
                  >
                    {{ dropItem.title }}
                  </DropdownItem>
                  <DropdownItem v-show="demoUrl" name="chgPassword"
                    >修改密码</DropdownItem
                  >
                  <DropdownItem name="logout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <!--<Avatar :src="avatorPath" style="background: #619fe7;margin-left: 12px;"></Avatar>-->
            </Row>
          </div>
        </div>
      </div>
    </div>
    <!--修改密码-start-->
    <Modal v-model="chgPassModal" title="修改密码">
      <Form ref="chgPassForm" :model="chgPassParams" :rules="chgPassRules" label-position="top">
        <FormItem prop="currentPassword" label="请输入原密码">
          <Input
            type="password"
            password
            v-model="chgPassParams.currentPassword"
            placeholder="请输入原密码"
          />
        </FormItem>
        <FormItem prop="newPassword" label="请输入新密码">
          <Input
            type="password"
            password
            v-model="chgPassParams.newPassword"
            placeholder="请输入新密码"
          />
        </FormItem>
        <FormItem prop="confirmPassword" label="请确认新密码">
          <Input
            type="password"
            password
            v-model="chgPassParams.confirmPassword"
            placeholder="请确认新密码"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelChgPass" type="text">取消</Button>
        <Button @click="chgPassWord" type="primary">确定</Button>
      </div>
    </Modal>
    <!-- 修改密码 -->
    <div class="single-page-con" :style="{ left: shrink ? '60px' : '240px' }">
      <div class="single-page" style="height: 100%">
        <keep-alive :include="cacheList">
          <router-view @change="change" ></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import shrinkableMenu from "./main-components/shrinkable-menu/shrinkable-menu.vue";
import breadcrumbNav from "./main-components/breadcrumb-nav.vue";
import fullScreen from "./main-components/fullscreen.vue";
import Cookies from "js-cookie";
import util from "@/libs/util";
import api from "@/libs/api";
import { queryOrganizationMetadata } from "@/api/appManagement";
import scrollBar from "@/views/my-components/scroll-bar/vue-scroller-bars/scroll-bar";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { clear } from 'idb-keyval'

export default {
  components: {
    shrinkableMenu,
    breadcrumbNav,
    fullScreen,
    scrollBar,
  },
  data() {
    return {
      isDown: true,
      menuShow: false,
      matedateclack: true,
      bookclack: true,
      demoUrl: true,
      shrink: false,
      userName: "",
      isFullScreen: false,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      currentPro: true,
      chgPassModal: false,
      chgPassParams: {
        username: Cookies.get("userName"),
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      cacheList: ['retention-analysis','data-quality-buried-point-analysis',"ltv-analysis", 'user-behavior-path'],
      chgPassRules: {
        currentPassword: [
          { required: true, message: "原密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: "新密码长度应该在6~50位之间",
            trigger: "change",
          },
          { validator: this.validatorPass, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: this.validatorConfirm, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      menuTree: (state) => state.app.menuTree,
      menuList: (state) => state.app.menuList,
      currentPath: (state) => state.app.currentPath, // 当前面包屑数组
      cachePage: (state) => state.app.cachePage,
      lang: (state) => state.app.lang,
      menuTheme: (state) => state.app.menuTheme,
      projectId: (state) => state.app.projectId,
      projectTitle: (state) => state.app.projectTitle,
      dropDown: (state) => state.app.dropDown,
      sidebarFooter: (state) => state.app.sidebarFooter,
      organizationId: (state) => state.user.organizationId,
      userInfo: (state) => state.user.userInfo,
      projectList: (state) => state.user.projectList,
    }),
    ...mapGetters(["hasMetadata", "hasBookMark", "dropDownList"]),
  },
  methods: {
    ...mapMutations([
      "RESET_eventAnalysis",
      "SET_META_DATA",
      "SET_EVENTS_GROUP_LIST",
      "SET_PROJECT_ID",
      "SET_PROJECT_TITLE",
      'SET_EVENTS_LIST',
      "SET_PROJECT_LIST",
      "SET_ORGANIZATION_PROPS",
      "SET_USER_GROUP_ID",
      "SET_USING_PANEL_ID",
      "SET_MENU_LIST",
      "SET_MARK_LIST",
      "clearOpenedSubmenu",
      "SET_FROM_URL",
      "SET_CHART_DASH",
      "SET_TIME_UNIT"
    ]),
    ...mapActions(["setEventsTags", "setDefaultMetaData"]),

    turnToPage(name) {
      switch (name) {
        case "metadata":
          this.goMetaPage();
          return;
        case "bookmark":
          this.getBookmark();
          return;
      }
    },
    demo() {
      let url = window.location.host;
      if (url.indexOf("demo") != -1) {
        this.demoUrl = false;
      }
    },
    ////
    getBookmark() {
      this.isDown = false;
      this.menuShow = true;
      this.matedateclack = true;
      this.bookclack = false;
      this.SET_FROM_URL("/");
      this.$router.push({ name: "bookmark-list" });
    },
    init(menuList, projectList) {
      const pathArr = util.setCurrentPath(this, this.$route.name);
      const defProjectId = this.projectId;
      console.log(defProjectId, 'defProjectIddefProjectId', this.userInfo)
      const groupId = this.userInfo.groups.find(
        (item) => item.projectId == defProjectId
      ).groupId;
      this.userName = Cookies.get("userName"); //用户邮箱
      this.SET_USER_GROUP_ID(groupId);
      if (pathArr.length >= 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      // projectList   判断项目列表是否为空，为空则不加载元数据
      if ((projectList.length != 0)) {
        api
          .getMetadata(this.projectId)
          .then((res) => {
            if (res.data.status === 1) {
              this.SET_META_DATA(res.data);
            }
          })
          .catch((err) => {
            this.setDefaultMetaData(this.projectId);
            // this.$Message.error("获取元数据失败");
          });
      }
    },
    toggleClick() {
      this.shrink = !this.shrink;
      this.SET_CHART_DASH(this.shrink);
    },
    handleClickUserDropdown(name) {
      if (name === "logout") {
        // 退出登录
        this.$store.commit("logout", this);
        this.$store.commit("clearOpenedSubmenu");
        this.$router.push({
          name: "login",
        });
        localStorage.clear()
        clear()
      } else if (name === "user-management") {
        this.$router.push({
          path: "/view/user-management",
        });
      } else if (name === "project-management") {
        this.$router.push({
          path: "/view/project-management",
        });
      } else if (name === "enterprise-overview") {
        this.$router.push({
          path: "/view/enterprise-overview",
        });
      } else if (name === "enterprise-config") {
        this.$router.push({
          path: "/view/enterprise-config",
        });
      } else if (name === "chgPassword") {
        this.chgPassModal = true;
      } else {
        this.$router.push({
          path: `/view/${name}/${this.projectId}`,
        });
      }
    },
    handleSubmenuChange(val) {
      this.bookclack = true;
      this.matedateclack = true;
    },
    changeShow(v) {
      this.menuShow = v;
    },
    changeDpwm(v) {
      this.isDown = v;
    },

    // 概览，书签跳转事件分析，改变选中
    change(v) {
      this.isDown = true;
      this.menuShow = v;
      this.bookclack = true;
      this.matedateclack = true;
    },
    handleResize() {
      setTimeout(() => {
        this.scrollBarResize();
      }, 300);
    },
    fullscreenChange(isFullScreen) {
      // console.log(isFullScreen);
    },
    scrollBarResize() {
      this.$refs.scrollBar.resize();
    },
    getProjectList() {
      api.getProjectList(this.organizationId).then((res) => {
        // if (groupId !== 3) {
        this.init(this.menuList, res.data.fields.list);
        // }
        this.SET_PROJECT_LIST(res.data.fields.list);
      });
    },
    // 元数据
    goMetaPage() {
      this.isDown = false;
      this.menuShow = true;
      this.matedateclack = false;
      this.bookclack = true;
      this.setEventsTags(this.projectId);
      this.$router.push({
        path: `/view/metadata/${this.projectId}`,
      });
    },
    //切换项目
    chgProject(value) {
      const projectId = Number(value.substring(0, value.indexOf("_")));
      this.RESET_eventAnalysis();
      this.SET_PROJECT_ID(projectId);
      this.SET_PROJECT_TITLE(value.substring(value.indexOf("_") + 1));
      this.SET_USING_PANEL_ID(null);
      this.currentPro = true;
      this.resetMetaData(projectId);
      this.SET_EVENTS_LIST([])
      localStorage.removeItem('event_analysis_cache')
      localStorage.removeItem('user_behavior_path_filter_list')
      localStorage.removeItem('SEeventNameChange')
      localStorage.removeItem('user_behavior_path_events')
      this.SET_TIME_UNIT('day')
      this.SET_MENU_LIST(
        this.menuTree.find((item) => item.projectId === projectId).children
      );
      // this.clearOpenedSubmenu();
    },
    // 重新获取元事件
    resetMetaData(id) {
      //重新获取概览列表
      util.setDashboardsMenu();
      //项目切换时重新设置用户在当前项目的分组id
      const groupId = this.userInfo.groups.find(
        (item) => item.projectId == id
      ).groupId;
      this.SET_USER_GROUP_ID(groupId);


      if ((this.projectList.length != 0)) {
        api
          .getMetadata(id) //项目切换时重新获取项目元数据
          .then((res) => {
            if (res.data.status === 1) {
              this.SET_META_DATA(res.data);
              this.$router.push({ path: "/view/home" });
            }
          });
      }
    },
    //修改密码-确定
    chgPassWord() {
      this.$refs.chgPassForm.validate((valid) => {
        if (valid) {
          api.chgPassword(this.chgPassParams).then((res) => {
            if (res.data.status === 1) {
              this.chgPassModal = false;
              this.$Message.success("修改密码成功！请使用新密码重新登录");
              this.$store.commit("logout", this);
              this.$store.commit("clearOpenedSubmenu");
              this.$router.push({
                name: "login",
              });
            }
          });
        }
      });
    },
    //修改密码-取消
    cancelChgPass() {
      this.chgPassModal = false;
    },
    //密码验证
    validatorPass(rule, value, callback) {
      const hasSpace = /^[^\s]{6,50}$/; //含空格
      const onlyNumber = /^\d+$/; //纯数字
      const onlyLetter = /^[a-zA-Z]+$/; //纯字母
      if (!hasSpace.test(value)) {
        callback(new Error("密码中不能包含空格"));
      } else if (onlyNumber.test(value) || onlyLetter.test(value)) {
        callback(new Error("密码不能为纯数字或纯字母"));
      } else {
        callback();
      }
    },
    validatorConfirm(rule, value, callback) {
      if (value !== this.chgPassParams.newPassword) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        callback();
      }
    },
    getCompanyMetaData() {
      queryOrganizationMetadata().then((res) => {
        this.SET_ORGANIZATION_PROPS(res.fields.props);
      });
    },
  },
  watch: {
    menuShow(v) {
      // this.changeBar();
    },
    $route(to) {
      console.log(/^(user-detail-table|user-info-list)/.test(to.name), to, 'toooo')
      if (/^(user-detail-table|user-info-list)/.test(to.name) || to.name.startsWith('ltv-analysis') || to.name.startsWith('user-behavior-path')) {
        this.cacheList = []
        setTimeout(() => {
          this.cacheList = ['retention-analysis','data-quality-buried-point-analysis',"ltv-analysis", 'user-behavior-path']
        }, 300)
      }




     /*  if (/^(retention-analysis|user-detail-table)$/.test(to.name)) {
        this.cacheList = ['retention-analysis']
      } else {
        this.cacheList = []
      } */

      this.$store.commit("setCurrentPageName", to.name);
      let pathArr = util.setCurrentPath(this, to.name);
      if (pathArr.length > 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }
      // this.checkTag(to.name);
      localStorage.currentPageName = to.name;
    },
    lang() {
      util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
    },
    openedSubmenuArr() {
      setTimeout(() => {
        this.scrollBarResize();
      }, 300);
    },
  },
  mounted() {
    window.addEventListener("resize", this.scrollBarResize);
  },
  created() {
    // 显示打开的页面的列表
    this.$store.commit("setOpenedList");
    //获取项目列表
    this.getProjectList();
    // 获取企业元数据
    this.getCompanyMetaData();
    //demo环境不显示修改密码
    this.demo();
    // this.changeBar();
  },
  dispatch() {
    window.removeEventListener("resize", this.scrollBarResize);
  },
};
</script>
<style scoped>
.logo-name {
  font-size: 30px;
  color: #fff;
  text-shadow: 1px 0 5px;
}

.logo-name-shrink {
  font-size: 20px;
  color: #fff;
  text-shadow: 1px 0 5px;
}

.sidebar-menu-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  width: 240px;
}

.sidebar-footer-item {
  width: 50%;
  line-height: 44px;
  text-align: center;
  color: #A7ABB3;
  font-size: 14px;
  background: #383C4D;
  cursor: pointer;
}

.sidebar-footer-item:hover {
  background: #0084FF;
  color: #fff;
}
.sidebar-footer-item-clack {
  background: #0084FF;
  color: #fff;
  width: 50%;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.header-project-con {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 200px;
  display: flex;
  align-items: center;
}

.current-project {
  line-height: 60px;
}

.current-project-name {
  cursor: pointer;
  color: #0084FF;
}

.sidebar-menu-footer-shrink {
  position: fixed;
  left: 0;
  bottom: 0;
  color: #fff;
  width: 60px;
  padding: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue